module.exports = __webpack_public_path__ + "img/底部.c64d1209.png";